export default "__VITE_ASSET__9cc2ff4d__"